export const REDACTED = '[REDACTED]';

export const DEFAULT_DENY_LIST: ReadonlyArray<string> = [
  'password',
  'password_hash',
  'password_confirmation',
  'git_credential',
  'git_credentials',
  'encrypted_secret',
  'secret',
  'authorization',
  'cookie',
  'access_token',
  'refresh_token',
  'jwt',
  'jwt_secret',
  'api_key',
  'private_key',
  'set-cookie'
];

export function redact<T>(value: T, deny: ReadonlyArray<string> = DEFAULT_DENY_LIST): T {
  const denySet = new Set(deny.map((k) => k.toLowerCase()));
  return walk(value, denySet) as T;
}

function walk(value: unknown, deny: Set<string>): unknown {
  if (value === null || value === undefined) return value;
  if (typeof value !== 'object') return value;
  if (Array.isArray(value)) {
    return value.map((v) => walk(v, deny));
  }
  const obj = value as Record<string, unknown>;
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (deny.has(k.toLowerCase())) {
      out[k] = REDACTED;
    } else {
      out[k] = walk(v, deny);
    }
  }
  return out;
}
